import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import { PendingNote } from './PendingNote'
import { PANEL_HEADING } from './panelLayout'

interface StatementStepperProps {
  position: number
  total: number
  // While the column waits, the wait is said in place of the position.
  waiting: boolean
  waitingText?: string
  onPrevious: (() => void) | null
  onNext: (() => void) | null
}

// The panel's heading: which statement is open, with the arrows that step through them beside it.
export const StatementStepper = ({
  position,
  total,
  waiting,
  waitingText,
  onPrevious,
  onNext,
}: StatementStepperProps) => (
  <div className="flex h-7 items-center justify-between gap-2">
    {waiting ? (
      <PendingNote text={waitingText} />
    ) : (
      <p className={PANEL_HEADING}>
        Statement {position.toLocaleString()}{' '}
        <span className="font-normal text-ink-subtle">
          of {total.toLocaleString()}
        </span>
      </p>
    )}
    <div className="flex shrink-0 items-center gap-1">
      <Button
        size="xs"
        theme="outline"
        isIcon
        disabled={!onPrevious}
        onClick={() => onPrevious?.()}
        title="Previous statement"
      >
        <ChevronLeftIcon />
      </Button>
      <Button
        size="xs"
        theme="outline"
        isIcon
        disabled={!onNext}
        onClick={() => onNext?.()}
        title="Next statement"
      >
        <ChevronRightIcon />
      </Button>
    </div>
  </div>
)
